import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { withRouter } from "react-router-dom"
//import { NavLink} from "react-router-dom";
import axios from 'axios'
import { connectNode } from '../../../../utils/global'
import { escapeHtml } from '../../../../utils/textFunctions'
import '../../../../styles/assets/css/admin/form2.css'
import { loadLocationWithMessage } from '../../../../actions/location'

import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline'

import Switch from '@material-ui/core/Switch'
import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button'
import FormControl from '@material-ui/core/FormControl'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import Email from '@material-ui/icons/Email'
import WarningIcon from '@material-ui/icons/Warning'
import Spinner from 'react-spinner-material'
//import { makeStyles } from "@material-ui/core/styles";

class PatientAssmEdit extends Component {
  constructor() {
      super();
      this.state = {
          status: false,
          message: '',
          loading: false,
          uid: 0,
          pid: 0,
          tracker_type: 1,
          day_mood: 1,
          day_sleep: 1,
          day_medication: 1,
          day_exercise: 1,
          day_anxiety: 1,
          week_phq4: 1,
          week_who5: 1,
          month_phq9: 1,
          month_asrm: 1,
          month_gad7: 1,
          month_psqi: 1,
          month_mtf: 1,
          three_month_covid: 1,
          twelve_month_well_being: 1,
          twelve_month_ders: 1,
          tracker_reminder: 0,
      }
  }

  componentDidMount() {
    this.getAssmStatus()
  }

  getAssmStatus = () => {
    axios({
      method: 'post',
      url: connectNode + 'admin/patient/get_assessments_status',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=UTF-8'
      },
      data: {
        uid: this.props.authReducer.uid,
        pid: this.props.match.params.pid,
      }
    })
    .then((result) => {
      if(typeof result['data'].uid != undefined) {
        //console.log(result['data'])
        this.setState({
          uid: result['data'].uid,
          tracker_type: result['data'].type,
          day_mood: this.transCheckedVal(result['data'].d_mood),
          day_sleep: this.transCheckedVal(result['data'].d_sleep),
          day_medication: this.transCheckedVal(result['data'].d_medication),
          day_exercise: this.transCheckedVal(result['data'].d_exercise),
          day_anxiety: this.transCheckedVal(result['data'].d_anxiety),
          week_phq4: result['data'].w_phq4,
          week_who5: result['data'].w_who5,
          month_phq9: result['data'].m_phq9,
          month_asrm: result['data'].m_asrm,
          month_gad7: result['data'].m_gad7,
          month_psqi: result['data'].m_psqi,
          month_mtf: result['data'].m_mtf,
          three_month_covid: result['data'].three_m_covid,
          twelve_month_well_being: result['data'].twelve_m_well_being,
          twelve_month_ders: result['data'].twelve_m_ders,
          tracker_reminder: result['data'].tracker_reminder,
          loading: true,
        })
      }
    })
  }

  transCheckedVal = (val) => {
    if(val == 2) { // disable
      return 0
    }
    return val
  }

  conditionSwitch = (val) => {
    var new_val = true
    if(val === 0) {
      val = false
    }
    return val
  }

  handleSwitchChange = (e, name) => {
    var val = 1
    if(e.target.checked === false) {
      val = 0
    }
    this.setState({
      [name]: val
    })
  }

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    })
  }

  handleChange2 = (e, name) => {
    this.setState({
      [name]: e.target.value
    })
  }

  handleSubmit = (e) => {
    e.preventDefault()
    var pid = this.props.match.params.pid
    axios({
      method: 'post',
      url: connectNode + 'admin/patient_edit/edit_assessment',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=UTF-8'
      },
      data: {
        uid: this.props.authReducer.uid,
        user: this.state,
        pid: pid,
      }
    })
    .then((result) => {
        if(result['data'] === 1) {
          this.setState({
            message: 'Changed successfully!',
          })
          window.scrollTo(0, 0)
        } else {
          this.setState({
            message: 'Something went wrong. Please try again.',
          })
          window.scrollTo(0, 0)
        }
      }
    )
  }

  handleUpdateStatus = (id) => {
    document.getElementById('warning_box').style.display = 'block'
  }

  confirmUpdate = (e) => {
    var pid = this.props.match.params.pid
    axios({
      method: 'post',
      url: connectNode + 'admin/patient_edit/edit_assessment',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=UTF-8'
      },
      data: {
        uid: this.props.authReducer.uid,
        user: this.state,
        pid: pid,
      }
    })
    .then((result) => {
      //console.log(result)
        if(result['data'] === 1) {
          var new_status = 0
          if(this.state.tracker_reminder == 1) {
            new_status = 2
          } else if(this.state.tracker_reminder == 2) {
            new_status = 1
          }
          this.setState({ tracker_reminder: new_status })
          this.closeWarningBox()
        }
      }
    )
  }

  closeWarningBox = (e) => {
    document.getElementById('warning_box').style.display = 'none'
  }

  render() {
    return (
      <div className="patient_edit">
        <div className="row">
          {!this.state.loading &&
          <div className="small-12 columns loading2">
            <Spinner color={"#bbbbbb"} radius={50}/>
          </div>}
          {this.state.loading &&
          <div className="small-12 columns ">
            { this.state.message !== '' &&
              <div className="warning_msg8">
                <div className="float_left1"><CheckCircleOutlineIcon /></div>
                <div className="txt_warning_msg1">{ this.state.message }</div>
              </div>}
            {this.state.uid > 0 &&
            <form id="make_appointment" onSubmit={this.handleSubmit}>
              <div className="row">
                <div className="small-12 columns">
                  <div className="title1">
                    Daily/Weekly Tracker
                    <span className="align_right2">
                    Email Reminders:
                    {(this.state.tracker_reminder==1 && ' Enabled') || (this.state.tracker_reminder!=1 && ' Disabled')}
                    <a onClick={()=>this.handleUpdateStatus(this.props.match.params.pid)}>
                    <Email className={(this.state.tracker_reminder==1 && 'icon_email active') || (this.state.tracker_reminder!=1 && 'icon_email inactive')} />
                    </a></span>
                  </div>
                </div>
                <div className="small-12 columns">
                  <div className="bg1">
                    <div className="row">
                      <div className="small-12 medium-3 columns">
                        <Switch
                          checked={this.state.day_mood}
                          onChange={(e) => this.handleSwitchChange(e, 'day_mood')}
                          color="primary" name="day_mood"
                          inputProps={{ 'aria-label': 'primary checkbox' }}
                        /> Mood
                      </div>
                      <div className="small-12 medium-3 columns">
                        <Switch
                          checked={this.state.day_sleep}
                          onChange={(e) => this.handleSwitchChange(e, 'day_sleep')}
                          color="primary" name="day_sleep"
                          inputProps={{ 'aria-label': 'primary checkbox' }}
                        /> Sleep
                      </div>
                      <div className="small-12 medium-3 columns">
                        <Switch
                          checked={this.state.day_medication}
                          onChange={(e) => this.handleSwitchChange(e, 'day_medication')}
                          color="primary" name="day_medication"
                          inputProps={{ 'aria-label': 'primary checkbox' }}
                        /> Medication
                      </div>
                      <div className="small-12 medium-3 columns">
                        <Switch
                          checked={this.state.day_exercise}
                          onChange={(e) => this.handleSwitchChange(e, 'day_exercise')}
                          color="primary" name="day_exercise"
                          inputProps={{ 'aria-label': 'primary checkbox' }}
                        /> Exercise
                      </div>
                      <div className="small-12 medium-3 columns">
                        <Switch
                          checked={this.state.day_anxiety}
                          onChange={(e) => this.handleSwitchChange(e, 'day_anxiety')}
                          color="primary" name="day_anxiety"
                          inputProps={{ 'aria-label': 'primary checkbox' }}
                        /> Anxiety
                      </div>
                      <div className="medium-6 columns show-for-medium">&nbsp;</div>
                    </div>
                  </div>
                </div>
                <div className="small-12 columns">
                  <div className="title1">
                    Monthly Assessments
                  </div>
                </div>
                <div className="small-12 columns">
                  <div className="bg1">
                    <div className="row">
                      <div className="small-12 medium-3 columns">
                        <Switch
                          checked={this.state.month_phq9}
                          onChange={(e) => this.handleSwitchChange(e, 'month_phq9')}
                          color="primary" name="month_phq9" disabled
                          inputProps={{ 'aria-label': 'primary checkbox' }}
                        /> PHQ-9
                      </div>
                      <div className="small-12 medium-3 columns">
                        <Switch
                          checked={this.state.month_asrm}
                          onChange={(e) => this.handleSwitchChange(e, 'month_asrm')}
                          color="primary"  name="month_asrm"
                          inputProps={{ 'aria-label': 'primary checkbox' }}
                        /> ASRM
                      </div>
                      <div className="small-12 medium-3 columns">
                        <Switch
                          checked={this.state.month_gad7}
                          onChange={(e) => this.handleSwitchChange(e, 'month_gad7')}
                          color="primary" name="month_gad7"
                          inputProps={{ 'aria-label': 'primary checkbox' }}
                        /> GAD-7
                      </div>
                      <div className="small-12 medium-3 columns">
                        <Switch
                          checked={this.state.month_psqi}
                          onChange={(e) => this.handleSwitchChange(e, 'month_psqi')}
                          color="primary" name="month_psqi"
                          inputProps={{ 'aria-label': 'primary checkbox' }}
                        /> PSQI
                      </div>
                      <div className="small-12 medium-3 columns">
                        <Switch
                          checked={this.state.month_mtf}
                          onChange={(e) => this.handleSwitchChange(e, 'month_mtf')}
                          color="primary" name="month_mtf"
                          inputProps={{ 'aria-label': 'primary checkbox' }}
                        /> MTF
                      </div>
                      <div className="medium-9 columns show-for-medium">&nbsp;</div>
                    </div>
                  </div>
                </div>
                <div className="small-12 columns">
                  <div className="title1">
                    Trimonthly Assessments
                  </div>
                </div>
                <div className="small-12 columns">
                  <div className="bg1">
                    <div className="row">
                      <div className="small-12 medium-3 columns">
                        <Switch
                          checked={this.state.twelve_month_well_being}
                          onChange={(e) => this.handleSwitchChange(e, 'twelve_month_well_being')}
                          color="primary" name="twelve_month_well_being" disabled
                          inputProps={{ 'aria-label': 'primary checkbox' }}
                        /> Well Being
                      </div>
                      <div className="medium-9 columns show-for-medium">&nbsp;</div>
                    </div>
                  </div>
                </div>
                <div className="small-12 columns">
                  <div className="title1">
                    Six-month Assessments
                  </div>
                </div>
                <div className="small-12 columns">
                  <div className="bg1">
                    <div className="row">
                      <div className="small-12 medium-3 columns">
                        <Switch
                          checked={this.state.twelve_month_ders}
                          onChange={(e) => this.handleSwitchChange(e, 'twelve_month_ders')}
                          color="primary" name="twelve_month_ders" disabled
                          inputProps={{ 'aria-label': 'primary checkbox' }}
                        /> DERS
                      </div>
                      <div className="medium-9 columns show-for-medium">&nbsp;</div>
                    </div>
                  </div>
                </div>
                <div className="small-12 columns text_align_right">
                  <Button variant="contained" color="primary" disableElevation
                   onClick={this.handleSubmit} type="submit">
                    Submit
                  </Button>
                </div>
              </div>
            </form>}
            {this.state.uid == 0 &&
              <div>Patient has not completed MINI assessments.</div>
            }
          </div>}
        </div>
        <div className="warning_box" id="warning_box">
          <div className="row">
            <div className="small-12 columns">
            <WarningIcon /> Are you sure you want to
            {(this.state.tracker_reminder == 1 && ' disable ') || (this.state.tracker_reminder == 2 && ' enable ')}
            email reminders for this patient?
            </div>
            <div className="small-12 columns margin_top_space1">
            <Button variant="contained" color="primary" className="margin_right_1" disableElevation
             onClick={this.confirmUpdate} type="button">Yes</Button>
           <Button variant="contained" color="primary" disableElevation
            onClick={this.closeWarningBox} type="button">No</Button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return state
}

const mapDispatchToProps = (dispatch) => ({
  onLoadPages(response) {
    dispatch({
      type: 'LOAD_USER_AUTH',
      payload: response,
    })
  },
  onLoadLocation(route, msg) {
    dispatch(loadLocationWithMessage(route, msg))
  },
})

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(PatientAssmEdit)
